<div class="sub-header px-3">
    <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
</div>
<div class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
    <div class="col-md-4 catalog-header d-flex px-3 py-1">
        <h5 class="mb-0 px-0">Web Account Management</h5>
    </div>
    <div class="col-md-8 px-4 search-input-block d-flex align-items-center justify-content-end">
        <ng-container>
              @if(addEditEnabled){
            <button (click)="addEditEnabled=false;userData = {}" nz-button nzType="default" class="d-flex align-items-center mr-10"
                [nzSize]="'default'">
                Cancel
            </button>
          
            <button (click)="saveEditAction()" nz-button nzType="primary" class="d-flex align-items-center mr-10" [nzSize]="'default'">
                {{userData && userData.userId ? 'Update':'Save'}}
            </button>
        }
            @if(!addEditEnabled){
             <button (click)="addEditEnabled=true" nz-button nzType="primary" class="d-flex align-items-center mr-10"
                [nzSize]="'default'">
                Add EDP
            </button>
        }
        </ng-container>
    </div>

</div>
<div class="row" *ngIf="isLoading"><app-spinner></app-spinner></div>
@if(!addEditEnabled){
<ng-container>
    <div [ngStyle]="{'height':webAccountList.length>0 ? '80vh': ''}"
        class="row p-0 mt-3 catalog-container justify-content-center  d-flex align-items-center" *ngIf="!isLoading">
        <div class="row p-0">
            <div class="col-md-12 row product-search-container p-3 mb-3 ml-5">
                <div class="col-md-12 mb-4 d-flex align-items-center">

                    <label class="mr-10">Search User By: <span class="text-danger">*</span></label>
                    <nz-radio-group [(ngModel)]="searchType" class="d-flex justify-content-between">
                        <label nz-radio nzValue="UserId">User Id</label>
                        <label nz-radio nzValue="AR">AR</label>
                        <label nz-radio nzValue="EDP">EDP</label>
                    </nz-radio-group>
                </div>

                <div class="col-md-12 d-flex align-items-center mb-2">
                    <div class="col-md-1">

                    </div>
                    <div class="form-check col-md-4 mr-10 position-relative">
                        <input [(ngModel)]="searchInput" style="height: 35px;" class="form-control">
                        <span class="error-text" *ngIf="invalidSearch && !searchInput ">
                            *Search Criteria is required.
                        </span>
                    </div>
                    <button (click)="searchUser()" nz-button nzType="primary" class="d-flex align-items-center mb-1" [nzSize]="'default'">
                        Search
                    </button>
                </div>
            </div>
            <div class="px-2 py-4 col-md-12 amd-list-container">
                <div class="col-md-12 px-2 searh-input-block d-flex align-items-center justify-content-between">
                    <div class="col-md-6">
                    <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;"
                        nzSize="default" [nzSuffix]="suffixIconSearch">
                        <input type="text" class="py-1" nz-input placeholder="Search For Org Code"
                            (keydown.enter)="searchArNo(SearchText.value)" [(ngModel)]="searchText" nzAllowClear
                            #SearchText />
                        <span class="close-icon" (click)="SearchText.value = '';searchArNo('')" class="px-1" nz-icon
                            nzType="close-circle"></span>

                    </nz-input-group>
                    <ng-template #suffixIconSearch>
                        <span class="search-icon" (click)="searchArNo(SearchText.value)" nz-icon
                            nzType="search"></span>
                    </ng-template>
                </div>
                    <div class="d-flex">
                        <button [disabled]="selectedUserList.length == 0" (click)="deleteUsers()" nz-button nzType="primary" class="d-flex align-items-center mr-10" [nzSize]="'default'">
                           <span  nz-icon nzType="delete"></span> Delete
                        </button>
                        <button nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'">
                            Linked AR/EDP
                        </button>
                    </div>
                </div>
                <ng-container>
                    <app-data-grid (editedRow)="editUser($event)" (selectedRows)="selectedUsers($event)" (deleteRow)="deleteUser($event)" [dataSet]="webAccountList" [columns]="webAccountColumns" [gridStyle]="'white'"></app-data-grid>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>}
@else{
<ng-container>
    <app-webaccount-add-edit (apiStatus)="toggleForm($event)" [userData]="userData" ></app-webaccount-add-edit>
</ng-container>
}